import { queryOptions, useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateEndpoints } from '@/modules/candidates/constants';

import { candidateAssessmentQueryKeys } from './queryKeys';

interface CandidateAssessmentPathParams {
  jobId: string;
  candidateId: string;
}

interface CandidateAssessmentQueryOptions {
  enabled?: boolean;
}

export const candidateAssessmentQueryOptions = ({
  jobId,
  candidateId,
}: CandidateAssessmentPathParams) =>
  queryOptions({
    queryKey: candidateAssessmentQueryKeys.detail(jobId, candidateId),
    queryFn: async () => {
      const { data } = await fetchClient.GET(candidateEndpoints.assessment, {
        params: { path: { jobId, candidateId } },
      });

      return data;
    },
    staleTime: 30_000,
  });

export const useCandidateAssessmentQuery = (
  params: CandidateAssessmentPathParams,
  options?: CandidateAssessmentQueryOptions,
) => {
  return useQuery({
    ...candidateAssessmentQueryOptions(params),
    enabled: options?.enabled,
  });
};
